type Specialty = {
  id: string | number | undefined;
  title: string | undefined;
  siteName: string | undefined;
};

export const medicalSpecialties: Specialty[] = [
  { id: "21", title: "Allergy/Immunology", siteName: "allergy-immunology" },
  { id: "19", title: "Anesthesiology", siteName: "anesthesiology" },
  { id: "2", title: "Cardiology", siteName: "cardiology" },
  { id: "1", title: "Dentistry", siteName: "dentistry" },
  { id: "25", title: "Dermatology", siteName: "dermatology" },
  { id: "26", title: "Emergency Medicine", siteName: "emergency-medicine" },
  { id: "16", title: "Endocrinology", siteName: "endocrinology" },
  { id: "15", title: "Family Medicine", siteName: "family-medicine" },
  { id: "13", title: "Gastroenterology", siteName: "gastroenterology" },
  {
    id: "37",
    title: "Hospital Administration",
    siteName: "hospital-administration"
  },
  { id: "104", title: "Hospitalist", siteName: "hospitalist" },
  { id: "12", title: "Infectious Disease", siteName: "infectious-disease" },
  { id: "3", title: "Internal Medicine", siteName: "internal-medicine" },
  { id: "32", title: "Medical Student", siteName: "medical-student" },
  { id: "20", title: "Nephrology", siteName: "nephrology" },
  { id: "11", title: "Neurology", siteName: "neurology" },
  { id: "33", title: "Nurse Practitioner", siteName: "nurse-practitioner" },
  { id: "4", title: "Nursing", siteName: "nursing" },
  {
    id: "5",
    title: "Obstetrics & Gynecology",
    siteName: "obstetrics-gynecology"
  },
  { id: "17", title: "Oncology", siteName: "oncology" },
  { id: "23", title: "Ophthalmology", siteName: "ophthalmology" },
  { id: "27", title: "Orthopedics", siteName: "orthopedics" },
  { id: "30", title: "Otolaryngology", siteName: "otolaryngology" },
  { id: "64", title: "Pain Management", siteName: "pain-management" },
  { id: "28", title: "Pathology", siteName: "pathology" },
  { id: "6", title: "Pediatrics", siteName: "pediatrics" },
  { id: "39", title: "Pharma News", siteName: "pharma-news" },
  { id: "24", title: "Pharmacy", siteName: "pharmacy" },
  {
    id: "124",
    title: "Physical Medicine & Rehab",
    siteName: "physical-medicine-rehab"
  },
  { id: "36", title: "Physician Assistant", siteName: "physician-assistant" },
  { id: "44", title: "Practice Management", siteName: "practice-management" },
  { id: "7", title: "Psychiatry ", siteName: "psychiatry" },
  { id: "14", title: "Pulmonology", siteName: "pulmonology" },
  { id: "22", title: "Radiology", siteName: "radiology" },
  { id: "18", title: "Rheumatology", siteName: "rheumatology" },
  { id: "8", title: "Surgery", siteName: "surgery" },
  { id: "144", title: "Urgent Care", siteName: "urgent-care" },
  { id: "10", title: "Urology", siteName: "urology" }
];

export default medicalSpecialties;
